import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";

import { getDistanceIn } from "../../utils";

import gameConstants from "../../constants/game";
import useRisingNumber from "../../hooks/useRisingNumber";
import ProgressRow from "./ProgressRow";

const GuessCountryRow = ({
  country,
  Alpha2Code,
  distance,
  direction,
  percent,
  sizePercent,
}) => {
  const { showScale } = useSelector(({ user }) => user.settings);

  const { settings } = useSelector(({ user }) => user);

  const risingPercent = useRisingNumber(
    parseFloat(!showScale ? percent : Math.min(sizePercent, 999)),
  );

  return (
    <Fragment>
      <div className="relative col-span-6 grid h-fit grid-cols-6 gap-1">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 2 }}
          className={`col-span-6 grid h-full grid-cols-6 gap-1`}
        >
          <div className="animate-reveal col-span-3 flex h-full flex-row items-center justify-start rounded border-2">
            <img
              className="mx-2 h-6 w-6 max-xs:hidden"
              alt={Alpha2Code}
              src={`/data/${Alpha2Code?.toLowerCase()}/flag.svg`}
            />
            <p className="flex-1 overflow-hidden text-ellipsis whitespace-pre-wrap text-center">
              {country}
            </p>
          </div>
          <div className="animate-reveal col-span-2 flex h-full items-center justify-center rounded border-2">
            {getDistanceIn(distance, settings.distanceUnit)}
          </div>

          <div className="animate-reveal col-span-1 flex h-full items-center justify-center rounded border-2 px-2">
            <img
              alt={gameConstants.directions[direction].imgAlt}
              src={gameConstants.directions[direction].imgSrc?.toLowerCase()}
              className="h-4 w-4"
            />
          </div>
        </motion.div>
        <ProgressRow />
      </div>

      <div className="animate-reveal animate-pop col-span-1 flex h-full items-center justify-center rounded border-2 text-center">
        {risingPercent.toFixed(0) + " %"}
      </div>
    </Fragment>
  );
};

export default GuessCountryRow;
